import React, { useContext } from 'react'
import { Container, Title } from '@provi/provi-components'
import { TemplateContext } from '../../../components/template/context'
import { useISAContext } from '../../../components/template/ISA/context'
import { TemplateFormIsa } from '../../../components/template-isa'
import { FormFomik } from './form'

export const StopFinancing = () => {
  const { creditPath, isMobile } = useContext(TemplateContext)
  const { goToNextScreen } = useISAContext()
  return (
    <TemplateFormIsa>
      <Container>
        <Title text="O que você acha que aconteceria com o ISA caso você decidisse parar de declarar renda e não pagar o seu financiamento com a Provi?" />
        <FormFomik data={creditPath && creditPath.ReadExpectedEventToStopReportingIncome} goToNextScreen={goToNextScreen} />
        {isMobile && <div style={{ height: '27px' }} />}
      </Container>
    </TemplateFormIsa>
  )
}
